import { createFileRoute } from '@tanstack/react-router';

import { DispatchBoard } from '@/components/deliveries/dispatch-board';
import { useAuth } from '@/lib/auth';
import { driversCollection } from '@/lib/collections';

/**
 * The dispatch board. Drivers are preloaded so the lanes are there on the
 * first paint; everything else is React Query and arrives a beat later.
 */
export const Route = createFileRoute('/deliveries/')({
  loader: async () => {
    await driversCollection.preload().catch(() => undefined);
  },
  component: DeliveriesPage,
});

function DeliveriesPage() {
  const { activeAccountId } = useAuth();

  if (!activeAccountId) {
    return <p className="text-muted-foreground text-sm">Choose a workspace first.</p>;
  }

  return <DispatchBoard accountId={activeAccountId} />;
}
